import ApiConfig from "../config/Api.config";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";

const url = `${ApiConfig.URLBase}/estado`

const listar = async (IdEstado: number): Promise<Response> => {

    const request: Request = {
        url: `${url}/listar/${IdEstado}`,
        metodo: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};


const EstadoService = {
    listar,
};

export default EstadoService;